import {ChangeDetectionStrategy, Component, inject} from "@angular/core";
import {SessionModel} from "../../session/session.model";
import {FooterMessageComponent} from "../../notification/message/footer-message.component";
import {MessageLevel} from "../../notification/message/message";
import {OrderingContextModel} from '../../ordering-context/ordering-context.model';
import {OrderModel} from "../order.model";

@Component({
    selector: "woa-order-errors-panel",
    templateUrl: "./order-errors-panel.component.html",
    imports: [
        FooterMessageComponent
    ],
    styleUrl: "./order-errors-panel.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderErrorsPanelComponent {
    public orderModel: OrderModel = inject(OrderModel);
    public orderingContextModel: OrderingContextModel = inject(OrderingContextModel);
    public sessionModel: SessionModel = inject(SessionModel);

    MessageLevel = MessageLevel;
}
